export const SUGGESTED_ROLES = [
  'Frontend Developer',
  'Backend Developer',
  'Full - Stack Developer',
  'Designer',
  'Ideation',
  'Business Development',
  'Product Development',
  'Marketing',
  'Hardware',
  'Buzzing around',
  'Moral support',
  'I do everything',
  'I work without a team',
  'Something else',
];
export const SUGGESTED_SKILLS = [
  'Python',
  'C#',
  'Google TensonFlow',
  'C++',
  'C+',
  'Cobalt',
  'CSS',
];



// WEBPACK FOOTER //
// ./src/constants/suggestions.js